// react
import React, { useState } from 'react'

// css
// FIXME:
// import '../../css/components/ChangePassword.styl'

// components
import { Input, Button } from '@st-operations/uikit/src/v2/index.js'

// hooks
import API from '@st-operations/uikit/API.js'
import { useUser } from '_hooks'
import User from '_lib/User'

// constants

const BUTTON_STYLE = {
  display: 'table',
  width: 'inherit',
  margin: 0,
}

const INITIAL_STATE = {
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: '',
}

// component
const ChangePassword = () => {
  useUser()
  const [formValues, setFormValues] = useState(INITIAL_STATE)

  const handleChange = (value, name) => {
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }))
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const { currentPassword, newPassword, confirmNewPassword } = formValues

    if (currentPassword === '') {
      toast.error('Please provide your current password.')
      return
    }

    if (newPassword !== confirmNewPassword) {
      toast.error('Entered passwords do not match!')
      return
    }

    if (newPassword === '') {
      toast.error('Password cannot be empty!')
      return
    }

    let params = {
      current_password: currentPassword,
      password: newPassword,
    }
    let sso_api = new API('https://sso.sharethis.com')
    //let sso_api = new API('http://localhost:7000');
    sso_api.token = User.token
    sso_api.post('/reset-password-with-token', params, (err) => {
      if (err) {
        let msg = err && err.message ? err.message : 'error'
        toast.error(msg)
      } else {
        let msg = 'your password has been updated'
        toast(msg)
      }
    })
  }

  return (
    <form id="change-password" onSubmit={handleSubmit}>
      <Input
        onChange={handleChange}
        value={formValues.currentPassword}
        placeholder="Current password"
        label="Current password"
        name="currentPassword"
        type="password"
        // autocomplete="current-password"
      />
      <Input
        onChange={handleChange}
        value={formValues.newPassword}
        placeholder="New password"
        label="New password"
        name="newPassword"
        type="password"
        // autocomplete="new-password"
      />
      <Input
        onChange={handleChange}
        value={formValues.confirmNewPassword}
        placeholder="Confirm new password"
        label="Confirm new password"
        type="password"
        name="confirmNewPassword"
        // autocomplete="new-password"
      />
      <div className="button-container">
        <Button type="submit" style={BUTTON_STYLE}>
          Update Password
        </Button>
      </div>
    </form>
  )
}
// export
export default ChangePassword
